document.addEventListener("DOMContentLoaded", () => {

  if (!window.matchMedia("(hover: none)").matches) return;

  const cards = document.querySelectorAll(".card-wrapper");

  let activeCard = null;

  let startY = 0;
  let moved = false;

  cards.forEach((card) => {

    const media = card.querySelector(".media--hover-effect");
    const link = card.querySelector("a[href]");

    if (!media || !link) return;

    // Track scroll vs tap
    card.addEventListener("touchstart", (e) => {
      startY = e.touches[0].clientY;
      moved = false;
    }, { passive: true });

    card.addEventListener("touchmove", (e) => {
      const deltaY = Math.abs(e.touches[0].clientY - startY);
      if (deltaY > 10) moved = true;
    }, { passive: true });

    card.addEventListener("click", (e) => {

      if (moved) return;

      const isActive = card.classList.contains("is-preview-active");

      // FIRST TAP → preview mode
      if (!isActive) {

        e.preventDefault();

        // close previous preview automatically
        if (activeCard && activeCard !== card) {
          activeCard.classList.remove("is-preview-active");
          activeCard.querySelector(".media--hover-effect")
            ?.classList.remove("is-preview");
        }

        card.classList.add("is-preview-active");
        media.classList.add("is-preview");

        activeCard = card;

        return;
      }

      // SECOND TAP → allow navigation (do nothing)
    });

  });

});